import { v4 as uuid } from "uuid";
import reactRouter from "../images/reactRouter.svg";
export const skillsData = [
  //   {
  //     type:'Frontend',
  //     list:[
  //         {
  //             name:'Reactjs',

  //         }
  //     ]
  //   }

  {
    id: uuid(),
    name: "Html",
    icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg",
  },

  {
    id: uuid(),
    name: "CSS",
    icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg",
  },

  {
    id: uuid(),
    name: "Javascript",
    icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
  },

  {
    id: uuid(),
    name: "ReactJs",
    icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
  },

  {
    id: uuid(),
    name: "NextJs",
    icon: "https://raw.githubusercontent.com/get-icon/geticon/master/icons/nextjs-icon.svg",
  },
  {
    id: uuid(),
    name: "Redux Toolkit",
    icon: "https://raw.githubusercontent.com/get-icon/geticon/master/icons/redux.svg",
  },
  {
    id: uuid(),
    name: "React Router Dom",
    icon: reactRouter,
  },

  {
    id: uuid(),
    name: "Tailwind",
    icon: "https://raw.githubusercontent.com/aniftyco/awesome-tailwindcss/06368ccf0e04a654b4f600eed59a55440cadc431/assets/logo.svg",
  },

  {
    id: uuid(),
    name: "Material-ui",
    icon: "https://raw.githubusercontent.com/get-icon/geticon/master/icons/material-ui.svg",
  },

  {
    id: uuid(),
    name: "Git",
    icon: "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
  },

  {
    id: uuid(),
    name: "Firebase",
    icon: "https://camo.githubusercontent.com/dd4b2422ed3bfc9da88c43d18550375c66f9584327dff7ecc19315ce50b96f07/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f66697265626173652f66697265626173652d69636f6e2e737667",
  },
];
